import { createAsyncThunk } from '@reduxjs/toolkit';
import { IApiError } from '@/models/apiError.model';
import { AUTH_SLICE_NAME } from './models';

import { AuthAPI } from '@/api';
import { appCookiesStorage, formatApiError } from '@/utils';
import {
  IChangePasswordDTO,
  IForgotPasswordDTO,
  IResetPasswordDTO,
  ISignInAuthorizedResponse,
  ISignInDTO,
  ISignInResponse,
  ISignInVerifyDTO,
} from '@/models/auth.model';
import { REFRESH_TOKEN_STORAGE_KEY } from '@/constants/common';

export const signIn = createAsyncThunk<ISignInResponse, ISignInDTO, { serializedErrorType: IApiError }>(
  `${AUTH_SLICE_NAME}/signIn`,
  async (data: ISignInDTO) => {
    const response = await AuthAPI.signIn(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const signInVerify = createAsyncThunk<
  ISignInResponse & ISignInAuthorizedResponse,
  ISignInVerifyDTO,
  { serializedErrorType: IApiError }
>(
  `${AUTH_SLICE_NAME}/signInVerify`,
  async (data: ISignInVerifyDTO) => {
    const response = await AuthAPI.signInVerify(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const forgotPassword = createAsyncThunk<void, IForgotPasswordDTO, { serializedErrorType: IApiError }>(
  `${AUTH_SLICE_NAME}/forgotPassword`,
  async (data: IForgotPasswordDTO) => {
    const response = await AuthAPI.forgotPassword(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const resetPassword = createAsyncThunk<void, IResetPasswordDTO, { serializedErrorType: IApiError }>(
  `${AUTH_SLICE_NAME}/resetPassword`,
  async (data: IResetPasswordDTO) => {
    const response = await AuthAPI.resetPassword(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const logOut = createAsyncThunk<unknown, undefined, { serializedErrorType: IApiError }>(
  `${AUTH_SLICE_NAME}/logOut`,
  async () => {
    const refreshToken = appCookiesStorage.getItem(REFRESH_TOKEN_STORAGE_KEY);

    if (!refreshToken) {
      throw new Error('Refresh token is not found');
    }

    const response = await AuthAPI.logOut({ refreshToken });
    return response.data;
  },
  { serializeError: formatApiError },
);

export const changePassword = createAsyncThunk<string, IChangePasswordDTO, { serializedErrorType: IApiError }>(
  `${AUTH_SLICE_NAME}/changePassword`,
  async (data) => {
    const response = await AuthAPI.changePassword(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
